import script from "./MelonRain.vue?vue&type=script&setup=true&lang=js"
export * from "./MelonRain.vue?vue&type=script&setup=true&lang=js"

import "./MelonRain.vue?vue&type=style&index=0&id=3095dde4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3095dde4"]])

export default __exports__